var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#a2a5b9",
    opacity: 0.3,
    cx: 8.333,
    cy: 8.333,
    r: 8.333,
    transform: "translate(1.667 1.667)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a2a5b9",
    d: "M11.595,15.37l2.53-5.061a.625.625,0,0,0-.559-.9H11.244V7.052a.625.625,0,0,0-1.184-.28l-2.53,5.061a.625.625,0,0,0,.559.9h2.322V15.09a.625.625,0,0,0,1.184.28Z",
    transform: "translate(-1.244 -1.071)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.1fb3cd1637b5a186f3c68802cdc7c669.svg";
export { ForwardRef as ReactComponent };